import { render, staticRenderFns } from "./SurveyFileUpload.vue?vue&type=template&id=5740b220&scoped=true&"
import script from "./SurveyFileUpload.vue?vue&type=script&lang=ts&"
export * from "./SurveyFileUpload.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyFileUpload.vue?vue&type=style&index=0&id=5740b220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5740b220",
  null
  
)

export default component.exports